<app-wa-table [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers" [isDataLoading]="loading"
  [areMoreData]="areMoreData()" (loadMore)="loadMore()" [data]="data" (headerClick)="changeSort($event)">
  <ng-template app-column let-event>
    <a [routerLink]="['/member/', event.NOC.toLowerCase(), changeNameForURL(event.MaName) ]" routerLinkActive="router-link-active" class="uppertext-black">{{event.MaName}}</a>
    <div *ngIf="event.MaStatusCode!==0;else padding"><span class="tag tag--suspended">{{event.MaStatus}}</span></div>
  </ng-template>
  <ng-template app-column let-event><lib-country-flag [name]="event.CShort" [id]="event.NOC"> </lib-country-flag></ng-template>
  <ng-template app-column let-event><div class="uppertext">{{event.Continent | transloco}}</div></ng-template>
  <ng-template app-column let-event>
    <ng-template #padding><div> </div></ng-template>
  </ng-template>

  <ng-template app-column-responsive let-event><a [routerLink]="['/member/', event.NOC.toLowerCase(), changeNameForURL(event.MaName) ]" routerLinkActive="router-link-active"
    class="uppertext-black-no-viewport">{{event.MaName}}</a>
    <div class="uppertext-no-viewport">
        <lib-country-flag [name]="event.CShort" [id]="event.NOC"> </lib-country-flag>
      </div>
      <div class="uppertext-no-viewport">{{event.Continent | transloco}}</div>
      <div> <span *ngIf="event.MaStatusCode!==0" class="tag tag--suspended">{{event.MaStatus}}</span>
      </div>
  </ng-template>
</app-wa-table>
